"use strict";

exports.__esModule = true;
exports.default = void 0;
var _common = require("../../utils/common");
const formElementFocus = () => _common.defaultFocus;
var _default = formElementFocus;
exports.default = _default;